import getMobileNoInfoService  from '../services/components/mobileno_info.jsx'


const getState = (mobileNoInfoState) => ({ type: "MOBILENO_INFO", mobileNoInfoState })  


export const mobileNoInfoAction = (mobileNo) => dispatch => {
    let state = [];

    getMobileNoInfoService((data, msg) => {

        if (msg === "success") {

            state = {
                status: 200,
                body: data
            }
        }
        else if(msg === "sessionout"){
            state={
                message: "sessionout",
                status: 401,
                body: data 
            }
        } else {
            state = data
        }
        dispatch(getState(state))
    }, mobileNo)
} 


// WEBPACK FOOTER //
// ./src/actions/mobilenoinfoaction.jsx